module.exports = __webpack_public_path__ + "static/media/men-stock-photo.67dc1674.webp";